import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { routes } from '../../../../consts';
import { User } from '../../../../pages/auth/models';
import { ChangePasswordComponent } from '../../../../pages/auth/components/change-password/change-password.component';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent {
  @Input() user: User;
  @Output() signOut: EventEmitter<void> = new EventEmitter<void>();
  public routes: typeof routes = routes;
  public flatlogicEmail: string = localStorage.getItem('email');

  constructor(private dialog: MatDialog){}

  public signOutEmit(): void {
    this.signOut.emit();
  }

  handleChangePasswordAction(){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      add: true,
      edit: false,
    };
    dialogConfig.width="600px";
    const dialogRef = this.dialog.open(ChangePasswordComponent, dialogConfig);
    // const sub = dialogRef.componentInstance.onAddUser.subscribe((user) => {
    //   }
    // );
  }
}
